<template>
  <SideNavigationContainer ref="sideNvigationContainer">
    <v-list-item v-if="isUserAdmin" class="corporations">
      <div class="d-flex flex-row align-center">
        <AdminCorporationSwitch />
      </div>
    </v-list-item>

    <v-list-item class="companies">
      <div class="d-flex flex-row align-center">
        <company-switch />
      </div>
    </v-list-item>

    <v-divider></v-divider>

    <NavigationList />

    <v-divider></v-divider>

    <v-list-item>
      <locale-switcher />
    </v-list-item>

    <div v-if="$vuetify.breakpoint.xs"
         :style="`height: ${$vuetify.application.top}px`">
      <!--kludge to get drawer to display below app bar on mobile view without hiding bottom of the drawer-->
    </div>
    <v-divider></v-divider>
  </SideNavigationContainer>
</template>

<script>
import LocaleSwitcher from '@/components/chrome/LocaleSwitcher';
import AdminCorporationSwitch from '@/components/chrome/AdminCorporationSwitch';
import CompanySwitch from '@/components/chrome/CompanySwitch';
import SideNavigationContainer from '@/components/navigation/SideNavigationContainer';
import NavigationList from '@/components/navigation/NavigationList';
import { isAdmin } from '../../utils/UserRoles';

export default {
  name: 'SideNavigation',

  components: {
    CompanySwitch,
    AdminCorporationSwitch,
    LocaleSwitcher,
    SideNavigationContainer,
    NavigationList,
  },

  computed: {
    isUserAdmin() {
      if (!this.$store.state.user.user) {
        return false;
      }

      return this.isAdmin(this.$store.state.user.user.roles);
    },
  },
  methods:{
    toggleDrawerOpen() {
      this.$refs.sideNvigationContainer.toggleDrawerOpen();
    },
  },

  data: () => {
    return {
      isAdmin,
    };
  },
};
</script>

<style scoped>
.corporations,
.companies {
  margin-top: 5px;
}
</style>
